module.exports = __webpack_public_path__ + "img/flowWisdomWhite.9fe4e798.png";